const notPossibleRu = {
  'notPossible': {
    'title': {
      'operation': 'Операция невозможна',
      'authorization': 'Авторизация невозможна',
    },
    'description': 'Нет доступных сеансовых ключей для подтверждения операции.\nДля получения нового комплекта ключей обратитесь в ближайшее отделение банка.\nВы можете сменить подтверждение операций на СМС через Информационный центр.',
  },
};

export default notPossibleRu;
